import { create } from 'zustand';
import { TransitionCallStatusStoreType } from '../types/store/transition-call-status.types';

export const useTransitionCallStatusStore = create<TransitionCallStatusStoreType>((set) => ({
  messageIds: {},
  appendMessageId: (messageId) =>
    set((state) => ({
      ...state,
      messageIds: {
        ...state.messageIds,
        [messageId]: new Date().toISOString(),
      },
    })),
}));
